import { Component, OnInit } from '@angular/core';
import {
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
  MatSnackBar,
  MatSnackBarConfig
} from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { Card, CardType } from '../components/info-card/Card';
import { DashboardService } from '../services/dashboard.service';

@Component({
  selector: 'vias-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
 

  cards: Card[] = [];
  
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'bottom';

  constructor(public snackBar: MatSnackBar, private dashboardService: DashboardService) {
    const config = new MatSnackBarConfig();
    config.verticalPosition = this.verticalPosition;
    config.horizontalPosition = this.horizontalPosition;
    config.duration = 5000;

    this.snackBar.open(
      'viaMarine NG, Yeni Jenerasyon Yönetim Sistemi',
      '',
      config
    );
  }

  ngOnInit(): void {
	this.cards = [];
	this.dashboardService.getCards().then(cards => {
		this.cards = cards.map(card => ({
			type: card.type === 'success' ? CardType.Success :
				  card.type === 'warning' ? CardType.Warning :
				  CardType.Info,
			title: card.title,
			summary: card.summary,
			summaryIcon: card.summaryIcon,
			count: card.count,
			link_name: card.link_name,
			link: card.link,
			icon: card.icon
		  }));
	});
  }

}
